import React, { useCallback } from 'react';
import styled from 'styled-components';
import MaskedInput from 'react-text-mask';
import { FieldError } from 'react-hook-form';

interface BirthDateInputProps {
	value: string;
	formError?: FieldError | undefined;
	isSmallScreen: boolean;
	onChange: (value: string) => void;
	onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

const BirthDateInput = React.forwardRef(
	({ value, formError, isSmallScreen = false, onChange, onBlur }: BirthDateInputProps, ref) => {
		const handleChange = useCallback(
			(e: React.ChangeEvent<HTMLInputElement>) => {
				onChange(e.target.value);
			},
			[onChange]
		);
		const mask = useCallback((rawValue: string) => {
			let dateRegex = [/[0-3]/, /[0-9]/];
			let monthRegex = [/[0-3]/, /[0-9]/];
			let yearRegex = [/[1-2]/, /\d/, /\d/, /\d/];
			if (rawValue[0] === '3') dateRegex = [/[0-3]/, /[0-1]/];
			if (rawValue[3] === '1') monthRegex = [/[0-1]/, /[0-2]/];
			if (rawValue[6] === '1') yearRegex = [/[1-2]/, /9/, /[3-9]/, /[0-9]/];
			if (rawValue[6] === '2') {
				yearRegex = [/[1-2]/, /0/, /[0-2]/, /[0-9]/];
				if (rawValue[8] === '2') {
					yearRegex = [/[1-2]/, /0/, /[0-2]/, /[0-1]/];
				}
			}
			return [
				dateRegex[0],
				dateRegex[1],
				'/',
				monthRegex[0],
				monthRegex[1],
				'/',
				yearRegex[0],
				yearRegex[1],
				yearRegex[2],
				yearRegex[3],
			];
		}, []);

		return (
			<BirthDateContainer isSmallScreen={isSmallScreen}>
				<InputGroup isError={typeof formError !== 'undefined'}>
					<StyledMaskedInput
						inputmode="numeric"
						render={(textMaskRef, props) => (
							<input
								{...props}
								ref={(node) => {
									textMaskRef(node);
									//@ts-ignore
									ref.current = node;
								}}
							/>
						)}
						onBlur={onBlur}
						value={value}
						placeholder={'Must match your ID'}
						guide={false}
						onChange={handleChange}
						mask={mask}
						$isSmallScreen={isSmallScreen}
					/>
				</InputGroup>
				{formError && <StyledText isSmall={isSmallScreen}>{formError.message}</StyledText>}
			</BirthDateContainer>
		);
	}
);
const BirthDateContainer = styled.div<{ isSmallScreen: boolean }>(({ theme, isSmallScreen }) => ({
	display: 'flex',
	flexDirection: 'column',
	// marginBottom: '10px',
	color: theme.colors.darkR,
	fontSize: isSmallScreen ? '14px' : '16px',
}));

const StyledMaskedInput = styled(MaskedInput)(({ $isSmallScreen }) => ({
	padding: 10,
	fontSize: $isSmallScreen ? '14px' : '18px',
	width: '100%',
}));

const StyledText = styled.p<{ isSmall?: boolean }>`
	color: #c53030;
	text-align: left;
	font-size: ${({ isSmall }) => (isSmall ? '14px' : '18px')};
	padding: ${({ isSmall }) => (isSmall ? '5px 0' : '10px 0')};
`;

const InputGroup = styled.div<{ isError: boolean }>(({ isError }) => ({
	flexDirection: 'row',
	border: `2px solid ${isError ? '#c53030' : '#dde1e3'}`,
	borderRadius: '4px',
	marginTop: '7px',
}));
export default BirthDateInput;
